(() => {
  'use strict';
  const root = document.getElementById('bs-first-offer');
  if (!root || !['besunset.com', 'www.besunset.com'].includes(location.hostname)) return;
  const words = JSON.parse(root.querySelector('[data-copy]').textContent);
  const text = name => words[name] || '';
  const seenKey = 'bs_seen_v1';
  const stateKey = 'bs_first_offer_v1';
  let seen, saved;
  try {
    seen = localStorage.getItem(seenKey);
    saved = JSON.parse(localStorage.getItem(stateKey) || 'null');
    localStorage.setItem(seenKey, seen || String(Date.now()));
  } catch (_) { return; }
  const params = new URLSearchParams(location.search);
  const adEntry = params.get('utm_campaign') === root.dataset.campaign &&
    params.get('utm_source') === 'instagram' && params.get('utm_medium') === 'paid_social';
  const previousHost = (() => { try { return new URL(document.referrer).hostname; } catch (_) { return ''; } })();
  const ownHost = /(^|\.)besunset\.com$/.test(previousHost);
  if (Number(root.dataset.orders) > 0) return;
  if (!saved && (!adEntry || seen || ownHost)) return;
  if (saved && ['expired', 'unavailable'].includes(saved.status)) return;
  if (!saved) {
    saved = {status: 'starting', entered: Date.now()};
    localStorage.setItem(stateKey, JSON.stringify(saved));
  }
  const dialog = root.querySelector('dialog');
  const form = root.querySelector('form');
  const error = root.querySelector('[data-error]');
  const action = root.querySelector('[data-action]');
  const code = root.querySelector('[data-code]');
  const clock = root.querySelector('[data-clock]');
  let current = null, anchor = 0, remaining = 0, interval, busy = false;
  const closeNewsletter = () => {
    if (!root.hidden) document.querySelector('.js-newsletter-popup.show .js-newsletter-popup-close')?.click();
  };
  document.querySelectorAll('.js-newsletter-popup').forEach(popup => {
    new MutationObserver(closeNewsletter).observe(popup, {attributes: true, attributeFilter: ['class']});
  });
  const persist = status => {
    saved = {status, entered: saved.entered};
    localStorage.setItem(stateKey, JSON.stringify(saved));
  };
  const hide = () => {
    root.hidden = true;
    document.body.classList.remove('bs-first-offer-active');
    document.documentElement.style.removeProperty('--bs-offer-height');
    if (dialog.open) dialog.close();
    clearInterval(interval);
  };
  const resize = () => document.documentElement.style.setProperty('--bs-offer-height', root.querySelector('[data-bar]').offsetHeight + 'px');
  const tick = () => {
    const seconds = Math.max(0, Math.ceil((remaining - (performance.now() - anchor)) / 1000));
    clock.textContent = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
    if (!seconds) { persist('expired'); hide(); }
  };
  const show = value => {
    if (!['open', 'active'].includes(value.status)) {
      if (['expired', 'unavailable'].includes(value.status)) persist(value.status);
      hide(); return;
    }
    current = value;
    persist(value.status);
    remaining = Math.max(0, (value.expires_at - value.server_time) * 1000);
    anchor = performance.now();
    root.hidden = false;
    document.body.classList.add('bs-first-offer-active');
    closeNewsletter();
    code.hidden = value.status !== 'active';
    code.textContent = value.code || '';
    code.setAttribute('aria-label', text('copy'));
    action.textContent = text(value.status === 'active' ? 'shop' : 'activate');
    resize(); clearInterval(interval); tick(); interval = setInterval(tick, 1000);
  };
  const api = async (path, payload) => {
    const response = await fetch(root.dataset.api + path, {
      method: payload ? 'POST' : 'GET', credentials: 'include', cache: 'no-store',
      headers: payload ? {'Content-Type': 'application/json'} : {},
      body: payload ? JSON.stringify(payload) : undefined,
      signal: AbortSignal.timeout(60000)
    });
    const value = await response.json();
    if (!response.ok && value.status !== 'invalid_email') throw new Error('retry');
    return value;
  };
  const refresh = async () => {
    let value = await api('/session');
    if (value.status === 'none' && adEntry && saved.status === 'starting' && Date.now() - saved.entered < 3600000) {
      value = await api('/session', {campaign: root.dataset.campaign, first_visit: true, source: 'instagram', medium: 'paid_social'});
    }
    show(value);
  };
  action.addEventListener('click', () => {
    if (current?.status === 'active') {
      const path = location.pathname + location.search;
      location.assign('/discount/' + encodeURIComponent(current.code) + '?redirect=' + encodeURIComponent(path));
    } else {
      error.textContent = '';
      dialog.showModal();
      form.querySelector('input').focus();
    }
  });
  code.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(current.code);
      root.querySelector('[data-live]').textContent = text('copied');
    } catch (_) { root.querySelector('[data-live]').textContent = current.code; }
  });
  root.querySelector('[data-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || !form.reportValidity()) return;
    busy = true; error.textContent = '';
    const button = form.querySelector('[type=submit]');
    button.disabled = true; button.textContent = text('checking');
    try {
      const value = await api('/claim', {email: form.querySelector('input').value.trim()});
      if (value.status === 'active') {
        show(value); dialog.close();
        root.querySelector('[data-live]').textContent = text('ready');
      } else if (value.status === 'invalid_email') error.textContent = text('invalid_email');
      else { error.textContent = text(value.status === 'expired' ? 'expired' : 'unavailable'); persist(value.status); }
    } catch (_) { error.textContent = text('retry'); }
    finally { busy = false; button.disabled = false; button.textContent = text('activate'); }
  });
  new ResizeObserver(resize).observe(root.querySelector('[data-bar]'));
  window.addEventListener('storage', event => { if (event.key === stateKey) refresh().catch(() => {}); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden && !busy) refresh().catch(() => {}); });
  refresh().catch(() => hide());
})();
